<template>
  <div class="fq-tab-section position-relative">
    <div id="trainingCourseList" class="accordion">
      <template v-if="training && training.activeTrainingCourses">
        <div v-for="trainingCourse in training.activeTrainingCourses" :key="trainingCourse.id" class="card">
          <div class="card-header" role="tab">
            <div
              :aria-controls="'collapse-' + trainingCourse.id"
              :aria-expanded="false"
              :data-bs-target="'#collapse-' + trainingCourse.id"
              class="mb-0"
              data-bs-toggle="collapse"
              role="menu"
            >
              <span class="faq-q-title textStyle">
                {{ trainingCourse.displayName }}
              </span>
              <div class="like-faq d-flex align-items-center" @click="$event.stopPropagation()">
                <router-link
                  v-module="{ code: moduleConstantes.MODULE_STUDEA_REGISTRATION }"
                  v-tooltip="{
                    title: this.$tc('global.add.title', 1, {
                      name: this.$tc('studea_manager.group.title', 1).toLowerCase(),
                    }),
                  }"
                  :to="{
                    name: 'TrainingGroupAdd',
                    params: { trainingCourseId: trainingCourse.id, trainingId: training.id },
                  }"
                  class="settings"
                >
                  <FontAwesomeIcon class="icon" icon="fa-light fa-plus" />
                </router-link>
                <router-link
                  v-tooltip="{
                    title: $tc('studea_manager.triad.title', 2),
                  }"
                  :to="{
                    name: 'studeaManagerTriadList',
                    params: { trainingCourseId: trainingCourse.id },
                  }"
                  class="settings"
                >
                  <FontAwesomeIcon class="icon" icon="fa-light fa-users" />
                </router-link>

                <router-link
                  v-tooltip="{
                    title:
                      $tc('studea_manager.home.title', 1) + $tc('studea_manager.trainingCourse.title', 1).toLowerCase(),
                  }"
                  :to="{
                    name: 'studeaManagerHome',
                    params: { trainingCourseId: trainingCourse.id },
                  }"
                  class="settings"
                >
                  <FontAwesomeIcon class="icon" icon="fa-light fa-gear" />
                </router-link>
              </div>
            </div>
          </div>
          <div
            :id="'collapse-' + trainingCourse.id"
            :aria-labelledby="'collapse-' + trainingCourse.id"
            class="collapse"
            :class="{
              show:
                (currentTrainingCourse && trainingCourse.id === currentTrainingCourse.id) ||
                (trainingCourse.triads && Object.keys(trainingCourse.triads).length),
            }"
            data-bs-parent="#trainingCourseList"
          >
            <div v-if="moduleManager().isModuleActive(moduleConstantes.MODULE_STUDEA_REGISTRATION)" class="groups">
              <div class="row">
                <template v-if="trainingCourse?.groups">
                  <div v-for="group in trainingCourse.groups" :key="group.id" class="col-lg-6 mb-3">
                    <TrainingGroupComponent
                      :trainingCourse="trainingCourse"
                      :training="training"
                      :group="group"
                      @createRegistration="createRegistration(group.cryptedId)"
                      @deleteGroup="deleteGroup"
                    />
                  </div>
                </template>
              </div>
            </div>
            <div v-else>
              <TriadUsersListComponent :search="false" :trainingCourse="trainingCourse" />
            </div>
          </div>
        </div>
      </template>
    </div>
    <BlockLoader :loading="loading" />
  </div>
</template>

<script>
import TrainingGroupComponent from "@/components/training/TrainingGroupComponent.vue";
import { moduleConstantes } from "@/constantes/module";
import { moduleManager } from "@/services/module/module-manager";
import TriadUsersListComponent from "@/components/triad/TriadUsersListComponent.vue";
import BlockLoader from "@/components/blocks/BlockLoader.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "TrainingTrainingCourseComponent",
  components: { FontAwesomeIcon, BlockLoader, TriadUsersListComponent, TrainingGroupComponent },
  props: {
    training: {
      type: Object,
      required: true,
    },
    currentTrainingCourse: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["createRegistration", "deleteGroup"],
  data() {
    return {};
  },
  computed: {
    moduleConstantes() {
      return moduleConstantes;
    },
  },
  mounted() {},
  methods: {
    moduleManager() {
      return moduleManager;
    },
    createRegistration(groupCryptedId) {
      this.$emit("createRegistration", groupCryptedId);
    },
    deleteGroup(groupCryptedId) {
      this.$emit("deleteGroup", groupCryptedId);
    },
  },
};
</script>

<style lang="scss" scoped>
#trainingCourseList {
  display: flex;
  flex-direction: column;
  min-height: 100px;
}

.loading {
  margin-left: 20px;
  width: 15px;
  height: 15px;
}

.settings {
  width: 35px;
  height: 30px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: var(--primary-color);
}

.settings + .settings {
  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    height: 12px;
    width: 1px;
    background: var(--primary-color);

    @include up-to-md {
      height: 0;
      width: 0;
    }
  }
}

.collapse {
  &.archive {
    background: $light-red;
  }
}

.faq-q-title {
  @include up-to-md {
    justify-content: flex-start !important;
  }

  .green {
    @include up-to-md {
      margin-right: 5px;
    }
  }
}

.faq .faq-layouting .fq-tab-section .accordion .card {
  cursor: initial;
}

.like-faq {
  justify-content: space-between;
  @include up-to-md {
    margin-top: 15px;
    margin-left: 18px;
    justify-content: inherit;
  }
}

.groups {
  padding: 20px 20px 0 20px;
}
</style>
